import { cn } from '@/lib/utils';
import type { UserRole } from '@/lib/types';

const ROLE_STYLES: Record<UserRole, { dot: string; label: string }> = {
  admin:    { dot: 'bg-thermal-orange', label: 'text-thermal-orange' },
  editor:   { dot: 'bg-thermal-red',    label: 'text-thermal-red' },
  reviewer: { dot: 'bg-thermal-purple', label: 'text-thermal-purple' },
  user:     { dot: 'bg-fg-faint',       label: 'text-fg-muted' },
};

export function RoleChip({ role }: { role: UserRole }) {
  const s = ROLE_STYLES[role];
  return (
    <span className={cn('status-chip border border-border', s.label)}>
      <span className={cn('status-chip-dot', s.dot)} />
      {role}
    </span>
  );
}
